import React from 'react';
import {useDispatch} from "react-redux";

import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/esm/Button";
import {setEmailConfirmationCode} from "../actionCreators/appAC";


const EmailConfirmationModal = () => {
    const dispatch = useDispatch();

    const dismiss = () => dispatch({
        type: 'TOGGLE_EMAIL_CONFIRMATION',
        toggle: false
    })

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={dismiss}
            className="email-verification-popup rbg-popup-generic"
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay overlay-second-modal"
        >
            <Modal.Header className="rbg-popup-generic__header">
                <Button
                    className="rbg-popup-generic__close-icon"
                    onClick={dismiss}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body email-verification-popup__body">
                <h1 className="email-verification-popup__title rbg-popup-generic__title">
                    Email verification
                </h1>
                <div className="email-verification-popup__text rbg-popup-generic__text">
                    <p className="email-verification-popup__paragraph">
                        In order for you to continue, Rebag needs to verify your email address.
                    </p>
                </div>
                <div className="email-verification-popup__cta-container">
                    <Button
                        onClick={() => dispatch(setEmailConfirmationCode(false))}
                        className="btn rbg-btn-black email-verification-popup__cta"
                        variant="secondary"
                    >
                        Verify
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default EmailConfirmationModal;